import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = { className?: string };

export const NotAvailable = ({ className }: Props) => {
    const { t } = useGranite();

    return (
        <p className={cn(className)}>
            {t("transportService.modal.description.noTransportAvailable")}
        </p>
    );
};
